import { Pipe, PipeTransform } from '@angular/core';
import { Agent, AgentKeys } from '@ag-common-lib/public-api';
import { AgentSearchService } from 'ag-common-svc/public-api';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { WhereFilterOperandKeys } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';

@Pipe({
  name: 'recipientsDataSourceByAgentDbIds',
})
export class RecipientsDataSourceByAgentDbIdsPipe implements PipeTransform {
  constructor(private agentSearchService: AgentSearchService) {}

  async transform(
    recipientsDbIds: string[],
    operand:
      | WhereFilterOperandKeys.notIn
      | WhereFilterOperandKeys.in
      | WhereFilterOperandKeys.arrayContains = WhereFilterOperandKeys.in,
  ): Promise<Agent[]> {
    const dbIdsCount = recipientsDbIds?.length;

    if (!dbIdsCount && operand === WhereFilterOperandKeys.in) {
      return [];
    }

    // One ask either way. The batching this replaces existed only because Firestore caps
    // `in` at thirty values and `not-in` at ten; a SQL predicate takes the whole set.
    const sort = [{ selector: AgentKeys.p_agent_first_name, desc: false }];
    const filter = dbIdsCount
      ? [BaseModelKeys.dbId, operand === WhereFilterOperandKeys.notIn ? 'noneof' : 'anyof', recipientsDbIds]
      : null;

    const response = await this.agentSearchService.search(filter ? { filter, sort } : { sort });

    return (response?.data ?? []) as Agent[];
  }
}
